import axios from 'axios';

/**
 * @description GET request for fetching the parents markets list
 * @returns success or failure for storage details
 */
export async function getPraentMarkets() {
  let markets = [];
  await axios
    .get(`${process.env.VUE_APP_JAVA_API_URL}/vigilance/parent/markets`)
    .then((response) => {
      markets = response.data.data;
    })
    .catch((err) => {
      throw err;
    });
  return markets;
}

/**
 * @description GET request for fetching the parents record types list
 * @returns List of Parent record types
 */
export async function getRecordTypesForParent() {
  let recordTypes = [];
  await axios
    .get(`${process.env.VUE_APP_JAVA_API_URL}/vigilance/parent/recordTypes`)
    .then((response) => {
      recordTypes = response.data.data;
    })
    .catch((err) => {
      throw err;
    });
  return recordTypes;
}

/* account deactviate delete API
 * to deactivate the account */
export async function deleteReport(id, reason) {
  const url = `${process.env.VUE_APP_JAVA_API_URL}/vigilance/reports/${id}`;
  let result = '';
  await axios
    .delete(url, { data: {reason} })
    .then((response) => {
      if (response.status === 200 && response.data) {
        result = response.data;
      }
    })
    .catch((err) => {
      console.log('delete report java api error', err); // eslint-disable-line no-console
      throw err.response.data;
    });
  return result;
}

/**
 * @description GET request for fetching the child markets list
 * @returns success or failure for storage details
 */
export async function getChildMarkets() {
  let markets = [];
  await axios
    .get(`${process.env.VUE_APP_JAVA_API_URL}/vigilance/child/markets`)
    .then((response) => {
      markets = response.data.data;
    })
    .catch((err) => {
      throw err;
    });
  return markets;
}

/**
 * @description GET request for fetching the child record types list
 * @returns List of Child record types
 */
export async function getRecordTypesForChild() {
  let recordTypes = [];
  await axios
    .get(`${process.env.VUE_APP_JAVA_API_URL}/vigilance/child/recordTypes`)
    .then((response) => {
      recordTypes = response.data.data;
    })
    .catch((err) => {
      throw err;
    });
  return recordTypes;
}

/**
 * @description GET request for fetching child prefill data
 * @param {number} vrmResponseId - The VRM response ID
 * @returns Prefill data for child reports
 */
export async function getChildPrepopulateData(vrmResponseId) {
  let prepopulateData = [];
  await axios
    .get(`${process.env.VUE_APP_JAVA_API_URL}/vigilance/child/prepopulate?vrmResponseId=${vrmResponseId}`)
    .then((response) => {
      prepopulateData = response.data.data;
    })
    .catch((err) => {
      throw err;
    });
  return prepopulateData;
}

export async function praseUploadedDocument(formPayload, file, hierarchy = 1) {
  const formData = new FormData();

  // Append the JSON payload as a string under `supportFormData`
  formData.append('supportFormData', JSON.stringify(formPayload));
  // Append the file
  formData.append('file', file);
  let parsedJson = {};
  await axios
    .post(
      `${process.env.VUE_APP_JAVA_API_URL}/vigilance/reports/parse?hierarchy=${hierarchy}`,
      formData
    )
    .then((response) => {
      parsedJson = response.data.data;
    })
    .catch((err) => {
      throw err.response.data;
    });
  return parsedJson;
}

export async function getPopupConfigForAddReport(
  reportTypeId,
  marketId,
  type = 'parent',
  vrmFormResponseJsonDataId = null
) {
  let popupConfig = [];
  let params = {};
  if (reportTypeId && marketId) {
    params = {
      reportTypeId,
      marketId
    };
  }
  if (vrmFormResponseJsonDataId) params.vrm_form_response_json_data_id = vrmFormResponseJsonDataId;
  await axios
    .get(`${process.env.VUE_APP_JAVA_API_URL}/vigilance/${type}/popup-config`, {
      params
    })
    .then((response) => {
      popupConfig = response.data.data;
    })
    .catch((err) => {
      throw err.response.data;
    });
  return popupConfig;
}
/**
 * Helper function to interpolate placeholders in an object (e.g., {{key}} -> value from vars)
 * @param {Object} obj - The object to interpolate
 * @param {Object} vars - The variables for replacement
 * @returns {Object} - The interpolated object
 */
function interpolateObject(obj, vars) {
  if (!obj || typeof obj !== 'object') return obj;
  const str = JSON.stringify(obj);
  const interpolated = str.replace(/{{(\w+)}}/g, (match, key) => {
    if (!(key in vars)) return match;

    const value = vars[key];
    if (typeof value === 'string') {
      // Properly escape special characters inside strings
      return JSON.stringify(value).slice(1, -1);
    }
    if (value === null) return 'null';
    if (typeof value === 'number' || typeof value === 'boolean') return value;
    return JSON.stringify(value);
  });
  return JSON.parse(interpolated);
}
/**
 * Dynamically fetch data based on apiConfig.
 *
 * @param {Object} apiConfig - The config object.
 * @param {string} apiConfig.url - The endpoint URL.
 * @param { Object } for replacing placeholders in URL dynamically
 * @param {string} [apiConfig.method='GET'] - HTTP method (GET, POST, etc.).
 * @param {Object} [apiConfig.params={}] - Query params (for GET) or body (for POST).
 * @param {string} [apiConfig.dataKey] - Optional key to extract nested response data.
 * @returns {Promise<any>} - Extracted response data or full response.
 */
export function fetchApiConfigData(apiConfig, interpolationVars) {
  const { url, method = 'GET', params = {}, dataKey, data } = apiConfig;
  const actualUrl = url.replace(/{(.*?)}/g, (_, key) => {
    if (key in interpolationVars) {
      return encodeURIComponent(interpolationVars[key]);
    }
    return `{${key}}`; // leave it untouched if not found
  });
  const fullUrl = `${process.env.VUE_APP_JAVA_API_URL}${actualUrl}`;

  const config = {
    method: method.toUpperCase(),
    url: fullUrl
  };
  // Use the actual params from apiConfig, ensuring all parameters are included
  const finalParams = { ...params };

   // Interpolate data if provided and add to config
  if (data) {
    config.data = interpolateObject(data, interpolationVars);
  }
  config.params = finalParams;
  return axios(config)
    .then((response) => {
      const responseData = response.data.data;
      return dataKey ? responseData?.[dataKey] ?? [] : responseData;
    })
    .catch((error) => {
      console.error(`API fetch error: ${url}`, error);
      throw error;
    });
}

export async function lockReportForm(reportFormJsonDataId) {
  let responseFlag = {};
  await axios
    .post(
      `${process.env.VUE_APP_JAVA_API_URL}/vigilance/reports/${reportFormJsonDataId}/lock`,
    )
    .then((response) => {
      if (response.status === 200 && response.data) {
        responseFlag = response.data;
      }
    })
    .catch((err) => {
      throw err.response.data;
    });
  return responseFlag;
}
export async function unlockReportForm(reportFormJsonDataId) {
  let responseFlag = {};
  await axios
    .post(
      `${process.env.VUE_APP_JAVA_API_URL}/vigilance/reports/${reportFormJsonDataId}/unlock`,
    )
    .then((response) => {
      if (response.status === 200 && response.data) {
        responseFlag = response.data;
      }
    })
    .catch((err) => console.log('unlock vigilance report java api error', err)); // eslint-disable-line no-console
  return responseFlag;
}
export async function submitVigilanceReport(payload) {
  let reportSavedInfo = {};
  await axios
    .post(`${process.env.VUE_APP_JAVA_API_URL}/vigilance/save/reports`, payload)
    .then((response) => {
      reportSavedInfo = response.data.data;
    })
    .catch((err) => {
      throw err.response.data;
    });
  return reportSavedInfo;
}

export async function submitVigilanceReportAttachments(payload) {
  let reportSavedInfo = {};
  await axios
    .post(`${process.env.VUE_APP_JAVA_API_URL}/vigilance/save/reports/attachments`, payload)
    .then((response) => {
      reportSavedInfo = response.data;
    })
    .catch((err) => {
      throw err.response.data;
    });
  return reportSavedInfo;
}

export async function submitUpdatedVigilanceReportAttachments(payload) {
  let reportSavedInfo = {};
  await axios
    .put(`${process.env.VUE_APP_JAVA_API_URL}/vigilance/update/reports/attachments`, payload)
    .then((response) => {
      reportSavedInfo = response.data;
    })
    .catch((err) => {
      throw err.response.data;
    });
  return reportSavedInfo;
}


export async function getParentDetails(payload) {
  let responseFlag = {};
  await axios
    .post(
      `${process.env.VUE_APP_JAVA_API_URL}/vigilance/parent/reports`,
      payload
    )
    .then((response) => {
      if (response.status === 200 && response.data) {
        responseFlag = response.data;
      }
    })
    .catch((err) => console.log('get vigilance parent java api error', err)); // eslint-disable-line no-console
  return responseFlag;
}

export async function getChildDetails(queryParams = {}, payload = {}) {
  try {
    const response = await axios.post(
      `${process.env.VUE_APP_JAVA_API_URL}/vigilance/child/reports`,
      payload,
      { params: queryParams }
    );
    if (response.status === 200 && response.data) {
      return response.data;
    }
  } catch (err) {
    console.log('get vigilance child java api error', err);
    return null;
  }
  return null;
}

/**
 * @description GET request for fetching a single vigilance report's data by ID
 * @param {number|string} reportFormJsonDataId - The ID of the report form JSON data
 * @returns {Promise<Object>} The report data object
 * @throws Will throw an error if the request fails
 */
export async function getVigilanceReportById(reportFormJsonDataId, hierarchy) {
  let reportData = null;
  const params = {
    hierarchy
  };
  await axios
    .get(
      `${process.env.VUE_APP_JAVA_API_URL}/vigilance/reports/data/${reportFormJsonDataId}`,
      {
        params
      }
    )
    .then((response) => {
      reportData = response.data.data;
    })
    .catch((err) => {
      throw err.response.data;
    });
  return reportData;
}

/**
 * @description PUT request to update an existing vigilance report
 * @param {number|string} reportId - The ID of the report to be updated
 * @param {Object} payload - The updated report data to be sent
 * @returns {Object} Updated report information
 */
export async function updateVigilanceReport(payload) {
  let responseFlag = {};
  await axios
    .put(`${process.env.VUE_APP_JAVA_API_URL}/vigilance/update/reports`, payload)
    .then((response) => {
      responseFlag = response.data.data;
    })
    .catch((err) => {
      throw err;
    });
  return responseFlag;
}

/**
 * @description GET request for fetching users that can be assigned to reports
 * @returns List of users available for assignment
 */
export async function getAssignedToUsers() {
  let users = [];
  await axios
    .get(`${process.env.VUE_APP_JAVA_API_URL}/vigilance/reports/assignedtousers`)
    .then((response) => {
      users = response.data.data;
    })
    .catch((err) => {
      throw err;
    });
  return users;
}

/**
 * @description GET request for fetching activity log for a vigilance report
 * @param {number} reportId - The ID of the report to get activity log for
 * @returns Activity log data
 */
export async function getActivityLog(reportId) {
  let activityLog = [];
  await axios
    .get(`${process.env.VUE_APP_JAVA_API_URL}/vigilance/reports/activitylog/${reportId}`)
    .then((response) => {
      activityLog = response.data.data;
    })
    .catch((err) => {
      throw err;
    });
  return activityLog;
}

/**
 * @description PUT request for assigning a report to a user
 * @param {number} reportId - The ID of the report to assign
 * @param {number} assignedTo - The user ID to assign the report to
 * @returns Success response
 */
export async function assignReportToUser(reportId, assignedTo) {
  let responseData = {};
  await axios
    .put(`${process.env.VUE_APP_JAVA_API_URL}/vigilance/reports/${reportId}/assignment`, {
      assignedTo
    })
    .then((response) => {
      responseData = response.data;
    })
    .catch((err) => {
      throw err;
    });
  return responseData;
}

/**
 * @description GET request for fetching the parents clients list
 * @returns success or failure for storage details
 */
export async function getClients() {
  let markets = [];
  await axios
    .get(`${process.env.VUE_APP_JAVA_API_URL}/vigilance/reports/configured-accounts`)
    .then((response) => {
      markets = response.data.data;
    })
    .catch((err) => {
      throw err;
    });
  return markets;
}

/**
 * rep consultant post API
* to update vigilance for existing users */
export async function UpdateVigilanceForRepConsultant(id, vigilance) {
    let res = {};
    await axios.put(`${process.env.VUE_APP_JAVA_API_URL}/vigilance/service/repconsultant/${id}/vigilance-permission?enableVigilance=${vigilance}`).then((response) => {
        res = response.data;
    }).catch((err) => {
        console.log('enable vigilance for existing repconsultant java api error', err); // eslint-disable-line no-console
    });
    return res;
}


/**
 * rep consultant post API
* to update vigilance for existing users */
export async function UpdateVigilanceForRepProjectManager(id, vigilance) {
    let res = {};
    await axios.put(`${process.env.VUE_APP_JAVA_API_URL}/vigilance/service/repprojectmanager/${id}/vigilance-permission?enableVigilance=${vigilance}`).then((response) => {
        res = response.data;
    }).catch((err) => {
        console.log('enable vigilance for existing rep project manager java api error', err); // eslint-disable-line no-console
    });
    return res;
}

/**
 * @description GET request for check whether vigilance is enabled or not to account
 * @returns true or false
 */
export async function checkVigilanceEnabledForAccount(accountId) {
  let res = false;
  await axios
    .get(`${process.env.VUE_APP_JAVA_API_URL}/vigilance/service/${accountId}/enabled`)
    .then((response) => {
      res = response.data?.data || false;
    })
    .catch((err) => {
      throw err;
    });
  return res;
}

/**
 * @description GET request to get the accounts which has viglance module enabled
 * @returns vigilance activated accounts list
 */
export async function getVigilanceActivatedAccountList() {
  let res = [];
  await axios
    .get(`${process.env.VUE_APP_JAVA_API_URL}/vigilance/service/accounts/enabled`)
    .then((response) => {
      res = response.data?.data || [];
    })
    .catch((err) => {
      throw err;
    });
  return res;
}

/**
 * @description put request to enable vigilance
 * @returns success or failure
 */
export async function enableVigilanceToSelectedAccount(accountId) {
  let res = {};
  await axios
    .put(`${process.env.VUE_APP_JAVA_API_URL}/vigilance/service/${accountId}/enable`)
    .then((response) => {
      res = response.data;
    })
    .catch((err) => {
      throw err;
    });
  return res;
}

/**
 * @description put request to disable vigilance
 * @returns success or failure
 */
export async function disableVigilanceToSelectedAccount(accountId) {
  let res = {};
  await axios
    .put(`${process.env.VUE_APP_JAVA_API_URL}/vigilance/service/${accountId}/disable`)
    .then((response) => {
      res = response.data;
    })
    .catch((err) => {
      throw err;
    });
  return res;
}

/**
 * @description post request for fetching the buttons based on record type
 * @returns success or failure for storage details
 */
export async function getStatusBasedOnRecordType(data) {
  let markets = [];
  await axios
    .post(`${process.env.VUE_APP_JAVA_API_URL}/vigilance/statuses`, data)
    .then((response) => {
      markets = response.data.data;
     })
    .catch((err) => {
      throw err;
    });
  return markets;
}
/**
 * @description POST request to get evidence submissions for a report
 * @param {number} reportFormJsonDataId - The report form JSON data ID
 * @returns List of evidence submissions
 */
export async function getEvidenceSubmissions(reportFormJsonDataId) {
  let res = {};
  await axios
    .post(`${process.env.VUE_APP_JAVA_API_URL}/vigilance/evidences`, {
      report_form_json_data_id: reportFormJsonDataId
    })
    .then((response) => {
      res = response.data;
    })
    .catch((err) => {
      throw err;
    });
  return res;
}

export async function getStatusWithPermission(payload) {
  let responseFlag = [];
  await axios
    .post(
      `${process.env.VUE_APP_JAVA_API_URL}/vigilance/statuses/flow/conditions`,
      payload
    )
    .then((response) => {
      if (response.status === 200 && response.data) {
        responseFlag = response.data.data || [];
      }
    })
    .catch((err) => console.log('get vigilance statuses flow conditions java api error', err)); // eslint-disable-line no-console
  return responseFlag;
}

/**
 * @description GET request to get the dashboard details
 * @returns vigilance dashboard details
 */
export async function getVigilanceDashboardDetails() {
  let res = {};
  await axios
    .get(`${process.env.VUE_APP_JAVA_API_URL}/vigilance/dashboardDetails`)
    .then((response) => {
      res = response.data?.data || {};
    })
    .catch((err) => {
      throw err;
    });
  return res;
}

/**
 * @description GET request to get the dashboard details
 * @returns vigilance dashboard details
 */
export async function getInstructionsContent(id) {
  let res = {};
  await axios
    .get(`${process.env.VUE_APP_JAVA_API_URL}/vigilance/guidanceNote?marketFormsMasterId=${id}`)
    .then((response) => {
      res = response.data?.data || {};
    })
    .catch((err) => {
      throw err;
    });
  return res;
}


export async function updateVigilanceEnabledPOC(payload) {
  let responseFlag = null;
  await axios
    .put(
      `${process.env.VUE_APP_JAVA_API_URL}/vigilance/vigilancePOCEnabled`,
      payload
    )
    .then((response) => {
      if (response.status === 200 && response.data) {
        responseFlag = response.data || null;
      }
    })
    .catch((err) => console.log('vigilancePOCEnabled java api error', err)); // eslint-disable-line no-console
  return responseFlag;
}

/**
 * @description get request to get comment for the report
 * @returns vigilance dashboard Comments
 */
export async function getCommentsForReport(id) {
  let res = [];
  await axios
    .get(`${process.env.VUE_APP_JAVA_API_URL}/vigilance/reports/${id}/comments`)
    .then((response) => {
      res = response.data?.data || {};
    })
    .catch((err) => {
      throw err;
    });
  return res;
}


/**
 * @description post request to add comment
 * @returns vigilance dashboard Comments
 */
export async function addComment(id, payload) {
  let res = null;
  await axios
    .post(`${process.env.VUE_APP_JAVA_API_URL}/vigilance/reports/${id}/comments`, payload)
    .then((response) => {
      res = response.data || null;
    })
    .catch((err) => {
      throw err.response.data;
    });
  return res;
}

/**
 * @description put request to edit comment
 * @returns vigilance dashboard Comments
 */
export async function editComment(id, commentId, content) {
  let res = null;
  await axios
    .put(`${process.env.VUE_APP_JAVA_API_URL}/vigilance/reports/${id}/comments/${commentId}`, { content })
    .then((response) => {
      res = response.data || null;
    })
    .catch((err) => {
      console.log(err);
      throw err.response.data;
    });
  return res;
}

/**
 * @description delete request to delete the comment
 * @returns vigilance dashboard comments
 */
export async function deleteComment(id, commentId) {
  let res = null;
  await axios
    .delete(`${process.env.VUE_APP_JAVA_API_URL}/vigilance/reports/${id}/comments/${commentId}`)
    .then((response) => {
      res = response.data || null;
    })
    .catch((err) => {
      throw err;
    });
  return res;
}

/**
 * @description delete request to resolve the comment
 * @returns vigilance dashboard comments
 */
export async function resolveComment(id, commentId, status) {
  let res = null;
  await axios
    .put(`${process.env.VUE_APP_JAVA_API_URL}/vigilance/reports/${id}/comments/${commentId}/resolve?userId=${localStorage.getItem('userId')}&status=${status}`)
    .then((response) => {
      res = response.data || null;
    }).catch((err) => {
      throw err;
    });
  return res;
}
/*
* send link to emails
* @returns to share the link to the internal users
*/
export async function sendLinkToEmails(payload) {
  let documentsInfo = {};
  await axios
    .post(`${process.env.VUE_APP_JAVA_API_URL}/vigilance/share/link`, payload)
    .then((response) => {
      documentsInfo = response.data;
    })
    .catch((err) => {
      throw err;
    });
  return documentsInfo;
}

/**
 * @description GET request to get the user details
 * @returns for share link
 */
export async function getShareUsersLists(id) {
  let res = [];
  await axios
    .get(`${process.env.VUE_APP_JAVA_API_URL}/vigilance/usersList?vrmResponseId=${id}`)
    .then((response) => {
      res = response.data?.data?.user_data || [];
    }).catch((err) => {
      throw err;
    });
  return res;
}

/**
 * @description GET request for generating and downloading vigilance report
 * @param {number} vrmResponseId - The VRM response ID
 * @returns success or failure for report generation
 */
export async function generateReport(vrmResponseId) {
  const response = await axios.get(
    `${process.env.VUE_APP_JAVA_API_URL}/vigilance/generateReport?vrmResponseId=${vrmResponseId}`,
    {
      responseType: 'blob' // Important for file downloads
    }
  );
  return response;
}